import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export const Section = ({
  children,
  className = '',
  id = ''
}: {
  children: React.ReactNode;
  className?: string;
  id?: string;
}) => <motion.section id={id} initial={{
  opacity: 0,
  y: 30
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true,
  margin: '-100px'
}} transition={{
  duration: 0.6
}} className={`${`${`py-10 md:py-14 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full ${className}`} bg-transparent pt-[1px] pb-[1px] pl-[1px] pr-[1px]`} pt-[0px]`} data-id="element-262">
    {children}
  </motion.section>;
export const CTAButton = ({
  children,
  href = '#pricing',
  className = '',
  fullWidth = false
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}) => <motion.a href={href} whileHover={{
  scale: 1.02
}} whileTap={{
  scale: 0.98
}} className={`${`${`inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-[#1A1A2E] gold-gradient-bg rounded-full shadow-[0_0_20px_rgba(212,175,55,0.3)] hover:shadow-[0_0_30px_rgba(212,175,55,0.5)] transition-shadow duration-300 ${fullWidth ? 'w-full' : ''} ${className}`} text-[15px] flex-row items-center justify-center`} pt-[2px] pb-[2px] pl-[3px] pr-[3px]`} data-id="element-263">
    {children}
  </motion.a>;
export const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 27,
    s: 35
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) {
          s--;
        } else {
          s = 59;
          if (m > 0) {
            m--;
          } else {
            m = 59;
            if (h > 0) {
              h--;
            }
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <div className="flex items-center justify-center space-x-2 text-2xl md:text-4xl font-serif font-bold text-brand-gold" data-id="element-264">
      <div className="bg-brand-surfaceLight px-4 py-2 rounded-lg border border-brand-gold/20 min-w-[3ch] text-center text-[#D4AF37]" data-id="element-265">
        {format(timeLeft.h)}
        <span className="text-sm block font-sans text-brand-muted font-normal" data-id="element-266">
          hs
        </span>
      </div>
      <span className="pb-6" data-id="element-267">:</span>
      <div className="bg-brand-surfaceLight px-4 py-2 rounded-lg border border-brand-gold/20 min-w-[3ch] text-center" data-id="element-268">
        {format(timeLeft.m)}
        <span className="text-sm block font-sans text-brand-muted font-normal" data-id="element-269">
          min
        </span>
      </div>
      <span className="pb-6" data-id="element-270">:</span>
      <div className="bg-brand-surfaceLight px-4 py-2 rounded-lg border border-brand-gold/20 min-w-[3ch] text-center" data-id="element-271">
        {format(timeLeft.s)}
        <span className="text-sm block font-sans text-brand-muted font-normal" data-id="element-272">
          seg
        </span>
      </div>
    </div>;
};